import RolePermissionName from "./RolePermissionName";
import RolePermissionLink from "./RolePermissionLink";


import RoleName from "../../../../auth/components/role/RoleDetail/RoleName";
import RoleLink from "../../../../auth/components/role/RoleDetail/RoleLink";
import { toStringDisplay as toStringGroupType } from "../../../types/models/GroupType.d";

import {NavLink, useParams} from "react-router";
import Refresh from "@mui/icons-material/Refresh";
import Clear from "@mui/icons-material/Clear";
import Grid from '@mui/material/Grid';
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";
import {percentageFormat, fixedFormat, currencyFormat} from "../../../../utils/numberFormat";
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import CheckBoxOutlineBlankOutlinedIcon from '@mui/icons-material/CheckBoxOutlineBlankOutlined';
import {Stack, Typography, Card, CardHeader, CardContent, IconButton} from "@mui/material";
import React from "react";
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const RolePermissionDetail = ({ data = {}, label = '', showTitle = true, refetch = undefined, scoped = false }) => {
    
    data = data || {}
        
    return (
        <Stack direction="column" spacing={3}>
            {showTitle &&
                <Stack direction="row" justifyContent="left" spacing={1}>
                    <Typography
                            sx={ { flex: '1 1 100%' } }
                            variant="h6"
                            component="div"
                            data-testid="RolePermission-detail-title"
                    >
                        { label || t`Role Permission` }: <RolePermissionName id={data?.id}/>
                    </Typography>
                    <Stack direction="row" justifyContent="right" spacing={1}>
                        {refetch &&
                            <IconButton size="medium" variant="contained" data-testid="RolePermission-refresh-button"
                                        color="inherit"
                                        onClick={refetch}>
                                <Refresh />
                            </IconButton>
                        }
                        {!scoped &&
                            <IconButton size="medium" variant="contained" data-testid="RolePermission-cancel-button"
                                        color="inherit"
                                        component={NavLink}
                                        to=".."
                                        relative="path"
                                        viewTransition={true}
                            >
                                <Clear />
                            </IconButton>
                        }
                    </Stack>
                </Stack>
            }
            <Grid container rowSpacing={2} columnSpacing={ { xs: 1, sm: 2, md: 3 } }>
                
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="roleId-label"><Trans>Role</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="roleId-value" >{ data.roleId ? (<RoleLink id={ data.roleId }/>) : '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="permission-label"><Trans>Permission</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="permission-value" >{ data.permission || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="createdAt-label"><Trans>Created At</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="createdAt-value" >{displayDateTime(data.createdAt) || '-' }</Grid>
                    
            </Grid>
        </Stack>
    )
}

export default RolePermissionDetail;
